import React from 'react';
import styled from 'styled-components';
import PageShell from '../components/PageShell';
import { CornerCard } from '../components/ui';
import { color, font } from '../theme/tokens';

// --- 样式定义 ---
const Content = styled(CornerCard)`
    max-width: 820px;
    margin: 0 auto;
    line-height: 1.95;
`;

const LastUpdated = styled.p`
    margin: 0 0 36px;
    padding-bottom: 20px;
    border-bottom: 1px solid ${color.line};
    display: flex;
    align-items: baseline;
    gap: 14px;
    font-size: 13px;
    letter-spacing: 0.2em;
    color: ${color.text3};
    time { font-family: ${font.mono}; letter-spacing: 0.06em; color: ${color.text2}; }
`;

const SubHeading = styled.h2`
    display: flex;
    align-items: baseline;
    gap: 14px;
    margin: 44px 0 16px;
    font-family: ${font.display};
    font-weight: 700;
    font-size: 20px;
    letter-spacing: 0.16em;
    color: ${color.text};
    span {
        font-family: ${font.mono};
        font-weight: 400;
        font-size: 13px;
        letter-spacing: 0.06em;
        color: ${color.bloodHi};
    }
`;

const Paragraph = styled.p`
    margin: 0 0 18px;
    font-size: 15px;
    color: ${color.text2};
    text-align: justify;
`;

const ContactInfo = styled.a`
    font-family: ${font.mono};
    color: ${color.bloodHi};
    text-decoration: none;
    border-bottom: 1px solid rgba(224, 70, 79, 0.45);
    padding-bottom: 1px;
    &:hover { color: ${color.textBright}; border-color: ${color.textBright}; }
`;

function Terms() {
    return (
        <PageShell title="規約" en="TERMS">
            <Content pad="48px 56px">
                <LastUpdated>最后更新 <time dateTime="2025-10-05">2025.10.05</time></LastUpdated>

                <Paragraph>
                    欢迎访问 終ノ空.com。在使用本站及其服务前，请仔细阅读以下协议。使用本站即表示您同意并接受本协议所有条款。
                </Paragraph>

                <SubHeading><span>01</span>服务说明</SubHeading>
                <Paragraph>
                    終ノ空.com 是一个由个人开发者维护的独立节点，旨在实现个人构想。本服务按“现状”基础提供，我们不保证数据流不会中断或没有错误。
                </Paragraph>

                <SubHeading><span>02</span>账户责任</SubHeading>
                <Paragraph>
                    您需要对您的访问凭证（ID及密钥）的保密性负责。所有通过您账户进行的指令，都将被视为您本人的操作。您同意不使用本接口进行任何非法或未经授权的黑客活动。
                </Paragraph>

                <SubHeading><span>03</span>行为准则</SubHeading>
                <Paragraph>
                    您同意不上传任何恶意代码、骚扰、诽谤、暴力、色情或侵犯第三方数据主权的内容。系统管理员保留审查、拦截或清除任何违规数据包的权利，且无需预先警告。
                </Paragraph>

                <SubHeading><span>04</span>内容归属</SubHeading>
                <Paragraph>
                    您在使用本服务时生成的数据（如：论坛日志、评论）归您所有。但是，您授予本站一个全球性的、非独占的许可，以复制、分发和展示这些数据，仅用于系统运营和节点推广。
                </Paragraph>

                <SubHeading><span>05</span>变更与终止</SubHeading>
                <Paragraph>
                    作为独立实验项目，管理员保留在任何时间修改、挂起或终止服务的权利。对于检测到滥用资源或违反协议的用户，系统有权执行强制下线或账户注销操作。
                </Paragraph>

                <SubHeading><span>06</span>免责声明</SubHeading>
                <Paragraph>
                    在法律允许的最大范围内，本站及其开发者不对因连接不稳定或服务中断导致的任何数据丢失、算力浪费或其他无形损失负责。
                </Paragraph>

                <SubHeading><span>07</span>协议修订</SubHeading>
                <Paragraph>
                    我们可能会不定时更新本协议。重大版本更新会通过系统广播通知，建议您定期检查本页面以获取最新状态。
                </Paragraph>

                <SubHeading><span>08</span>联系方式</SubHeading>
                <Paragraph>
                    如对本协议有疑问，请联系：<ContactInfo href="mailto:abyss.gate@outlook.com">abyss.gate@outlook.com</ContactInfo>
                </Paragraph>
            </Content>
        </PageShell>
    );
}

export default Terms;
